module.exports = __webpack_public_path__ + "static/img/bg_tw.e49505e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_tw.png
// module id = zr/P
// module chunks = 1